<template>
<div>
    <v-data-table
        :headers="headers"
        :items="cobrados"
        :items-per-page="topItems"
        :loading="loading"
        loading-text="Carregando... Por favor aguarde."             
        no-data-text="Nenhuma informação encontrada"
        no-results-text="Nenhuma informação encontrada"
        :sort-by="['PeriodoFinal']"
        :sort-desc="[true]"                  
        class="">
        <template v-slot:item.anexo="{ item }">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" viewBox="0 0 30 30" @click="gerarRelatorio(item)">
                <defs>
                    <path id="a" d="M29.631 6.495L23.481.363A1.23 1.23 0 0 0 22.613 0H2.435A2.438 2.438 0 0 0 0 2.45v25.1C0 28.903 1.09 30 2.435 30h25.107a2.427 2.427 0 0 0 2.435-2.419L30 7.368a1.317 1.317 0 0 0-.369-.873zm-1.137 5.026l-.007 7.607v7.99c0 .726-.6 1.321-1.33 1.321H2.828a1.33 1.33 0 0 1-1.329-1.321V2.805c0-.726.6-1.321 1.33-1.321h16.244c.73 0 1.329.595 1.329 1.321V6.72c0 1.469 1.13 2.635 2.62 2.635h4.144c.73 0 1.33.595 1.33 1.322v.845zm-17.206 2.462a.979.979 0 0 0-.99.965v6.044c0 .533.437.965.99.965h17.457v-7.974H11.288zm5.356 6.893l-1.412-2.246-1.412 2.246h-1.366l2.01-3.056-1.887-2.872h1.42l1.304 2.13 1.282-2.13h1.388l-1.903 2.941 2.05 2.987h-1.474zm2.233 0v-5.935h1.281v4.893h2.456l.008 1.042h-3.745zm7.788-.386c-.39.31-.936.463-1.642.463-.644 0-1.22-.115-1.71-.355v-1.165c.406.177.751.309 1.043.378.284.07.545.108.775.108.284 0 .498-.054.644-.154.146-.1.23-.263.23-.471a.495.495 0 0 0-.1-.309 1.109 1.109 0 0 0-.29-.262c-.131-.085-.392-.216-.784-.402-.368-.17-.644-.332-.836-.494a1.792 1.792 0 0 1-.445-.548c-.115-.208-.161-.455-.161-.733 0-.525.184-.934.545-1.235.36-.301.867-.455 1.504-.455.314 0 .614.038.905.108.292.07.583.177.898.308l-.414.973a6.45 6.45 0 0 0-.798-.27 2.551 2.551 0 0 0-.63-.077c-.245 0-.43.054-.56.17a.555.555 0 0 0-.2.44.54.54 0 0 0 .077.293.85.85 0 0 0 .254.24c.115.076.39.215.82.416.568.262.96.532 1.167.803.215.262.315.594.315.98-.016.517-.208.95-.607 1.25z"/>
                </defs>
                <g fill="none" fill-rule="evenodd">
                    <path fill="#FFF" fill-rule="nonzero" d="M29.631 6.495L23.481.363A1.23 1.23 0 0 0 22.613 0H2.435A2.438 2.438 0 0 0 0 2.45v25.1C0 28.903 1.09 30 2.435 30h25.107a2.427 2.427 0 0 0 2.435-2.419L30 7.368a1.317 1.317 0 0 0-.369-.873z"/>
                    <mask id="b" fill="#fff">
                        <use xlink:href="#a"/>
                    </mask>
                    <use fill="#26C184" fill-rule="nonzero" xlink:href="#a"/>
                    <g fill="#64A70B" mask="url(#b)">
                        <path d="M0 0h30v30H0z"/>
                    </g>
                </g>
            </svg>
        </template>
        <template v-slot:item.DataFiltro="{ item }">
            {{ FormatarData(item.DataFiltro) }}
        </template>

        <template v-slot:item.PeriodoInicial="{ item }">
            {{ FormatarData(item.PeriodoInicial) }}
        </template>
        <template v-slot:item.PeriodoFinal="{ item }">
            {{ FormatarData(item.PeriodoFinal) }}
        </template>                

        <template v-slot:item.Segurados="{ item }">
            {{ FormatarValorNumerico(item.Segurados) }}
        </template>        
    </v-data-table>

    <v-overlay :value="fullLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>    
</div>    
</template>

<script>
import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import Helpers from "@/utilities/Helpers";
import { constants } from 'fs';

    export default {
        mixins: [Helpers],
        data() {
            return {
                baseURL: Vue.prototype.$httpPortal.defaults.baseURL,
                loading: true,
                fullLoading: false,
                topItems: 10,
                totalItems: 1000,
                offset: 1,
                options: {},                    
                headers: [
                    {text: "Data de Execução", value: "DataFiltro", sortable: true},
                    //{text: "Período", value: "DataArquivo", sortable: true},
                    {text: "Data Inicial do Relatório", value: "PeriodoInicial", sortable: true},
                    {text: "Data Final do Relatório", value: "PeriodoFinal", sortable: true},
                    {text: "Nº de Vidas", value: "Segurados", sortable: true},
                    {text: "Download", value: "anexo", sortable: false}
                ],
                cobrados: []
            }
        },
        methods: {
           requestRelatorioCobrados()
           {
                this.fullLoading = true;
                let codigoCorretor = this.usuario.codCorretor;
                let url = "Relatorio/Disponivel/"+codigoCorretor+"/Cobrado/Corretor";

                Vue.prototype.$httpPortal.get(url)
                .then(res => {
                    console.log(res.data);
                    this.cobrados = res.data
                    this.loading = false
                    this.fullLoading = false;
                })
                .catch(ex => {
                    console.log(ex);
                    this.loading = false;
                    this.fullLoading = false;
                });    
           },
            gerarRelatorio(value){
                let codigoCorretor = this.usuario.codCorretor;
                let url = this.baseURL + "Relatorio/SeguroCobradoExcel/" + codigoCorretor +"/" + this.FormatarData(value.DataFiltro).split('/').join('-');
                window.open(url, "_blank");                
            },
            FormatarValorNumerico(valor)
            {
                return valor.toLocaleString('pt-br', {minimumFractionDigits: 0});
            },              

        },
        watch: {
            options(value){
                if(this.offset != value.page)
                {
                    this.offset = value.page
                    this.topItems = value.itemsPerPage
                    this.requestRelatorioCobrados()
                }
            }
        },         
        computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
        },        
        mounted(){            
            this.requestRelatorioCobrados();
        }                  
    }
</script>
